<ng-container *ngIf="vm$ | async as vm">
  <ng-container *ngIf="status$ | async as status">
    <div class="tab-container" [class.tab-container--loading]="status.loading">
      <div *ngIf="status.loading">
        <df-spinner [isSpinning]="status.loading"></df-spinner>
      </div>

      <ng-container *ngIf="!status.loading">
        <ul class="guts-p-b-1 guts-m-l-3">
          <li
            *ngFor="let group of vm.groups; let first = first"
            class="
              l_flex
              m-l_flex
              l_flex-justif
              border-bottom
              guts-m-b-1 guts-p-b-1 guts-p-r-1
            "
            [class.guts-p-t-2]="first"
            data-dgat="groups-tab-813"
          >
            <div class="l_flex m-l_flex l_flex-middle l_flex-grow">
              <div class="group-icon">
                <df-icon icon="person-triple" class="guts-p-r-1"></df-icon>
              </div>

              <div
                role="button"
                class="item-link"
                (click)="goToGroup(group)"
                data-dgat="groups-tab-e57"
              >
                {{ group.name }}
              </div>
            </div>
            <div class="l_flex m-l_flex l_flex-shrink">
              <button
                *ngIf="group.isMutualGroup"
                df-button
                dfButtonType="primary"
                (click)="leaveGroup(group)"
                [ngbTooltip]="i18n.dgGroupOverview_LeaveGroup"
                data-dgat="groups-tab-64a"
              >
                <df-spinner-button
                  [isSpinning]="status.groupSubmittingId === group.groupId"
                ></df-spinner-button>
                <span>
                  <df-icon icon="checkmark"></df-icon>
                  {{ i18n.Core_Joined }}
                </span>
              </button>

              <ng-container *ngIf="!group.isMutualGroup">
                <button
                  *ngIf="group.privacyLevel === 0"
                  df-button
                  dfButtonType="passive"
                  (click)="joinGroup(group)"
                  data-dgat="groups-tab-b3b"
                  class="
                    btn btn-passive
                    no-border
                    bg-color-ebony-a08
                    color-ebony
                    profile-button
                  "
                >
                  <df-spinner-button
                    [isSpinning]="status.groupSubmittingId === group.groupId"
                  >
                    <div class="l_flexbar gap-full-half">
                      <df-icon icon="plus"></df-icon>
                      <div>{{ i18n.Core_Join }}</div>
                    </div>
                  </df-spinner-button>
                </button>

                <button
                  *ngIf="group.privacyLevel === 1 && !group.isPendingMember"
                  df-button
                  dfButtonType="passive"
                  df-button-small
                  class="
                    btn btn-passive
                    no-border
                    bg-color-ebony-a08
                    color-ebony
                    profile-button
                  "
                  (click)="requestMembership($event, group)"
                  data-dgat="groups-tab-0e7"
                >
                  <div class="l_flexbar gap-full-half">
                    <df-icon icon="plus"></df-icon>
                    <div [innerHTML]="i18n.dgGroupTile_RequestMembership"></div>
                  </div>
                </button>

                <button
                  *ngIf="group.isPendingMember"
                  df-button
                  dfButtonType="ghost"
                  df-button-small
                  class="
                    btn btn-passive
                    no-border
                    bg-color-ebony-a08
                    profile-button
                  "
                  data-dgat="groups-tab-af6"
                >
                  <span class="l_flexbar">
                    <df-icon
                      icon="checkmark"
                      class="guts-m-r-half v-top"
                    ></df-icon>
                    <span
                      class="ib-v-middle off-hover color-blue"
                      [innerHTML]="i18n.dgGroupTile_JoinRequestPending"
                    ></span>
                  </span>
                </button>
              </ng-container>
            </div>
          </li>
        </ul>
      </ng-container>
    </div>
  </ng-container>
</ng-container>
